import { Link, Navigate, useSearchParams } from "react-router-dom";
import { ksFacturesQK } from "../lib/query-keys";
import { useQuery } from "@tanstack/react-query";
import { findOneFacture } from "../lib/queries/factures-queries";
import { Alert } from "../components/ui/alert";
import { Button } from "../components/ui/button";
import Box from "../components/ui/Box";
import { Skeleton } from "../components/ui/skeleton";
import Title from "../components/ui/Title";
import Divider from "../components/ui/Divider";
import { CheckCircle } from "lucide-react";

const ConfirmerAchatPage = () => {
  const [params] = useSearchParams();
  const id = params.get("id");
  const { data: facture, isError } = useQuery({
    queryKey: [ksFacturesQK, id],
    queryFn: () => findOneFacture(id),
  });

  // Si ID Manquant
  if (!id) return <Navigate to={"/boutique"} />;

  // Si erreur
  if (isError) {
    return <Alert variant={"destructive"}>Une erreur s'est produite.</Alert>;
  }

  if (!facture) {
    return <Skeleton className="w-full h-24" />;
  }

  // Si ok
  return (
    <div className="text-center">
      <div className="flex gap-7 justify-center items-center">
        <CheckCircle className=" w-14 h-14 text-green-800" />
        <Title>Commande reçue</Title>
      </div>

      <Divider className="my-7" />
      <Title order={2} className="italic mb-5">
        Consignes de paiement :
      </Title>
      {facture.modePaiement === "CHQ" && (
        <>
          <div className="mb-5">
            Pour régler votre commande, veuillez envoyer un chèque d'un montant
            de <strong>{(facture.montant / 100).toFixed(2)} €</strong> à l'ordre{" "}
            {facture.sna
              ? "du Syndicat National d'Apiculture"
              : "de l'Abeille de France"}{" "}
            en indiquant comme référence le numéro de facture{" "}
            <strong>{facture.numero}</strong>, à l'adresse postale : <br />
          </div>
          <Box>
            <strong>
              {facture.sna
                ? "Syndicat National d'Apiculture"
                : "L'Abeille de France"}
            </strong>
            <br />5 rue de Copenhague
            <br />
            75008 Paris
            <br />
            France
          </Box>
        </>
      )}
      {facture.modePaiement === "VIR" && (
        <>
          <div className="mb-4">
            Veuillez envoyer un virement de{" "}
            <strong>{(facture.montant / 100).toFixed(2)}€</strong> en indiquant
            comme référence le numéro de facture{" "}
            <strong>{facture.numero}</strong>.
          </div>
          <Box>
            <strong>IBAN</strong> : FR05 3000 2004 3800 0000 7188 H31
            <br />
            <strong>BIC</strong> : CRLYFRPP
          </Box>
        </>
      )}
      <Link to={"/boutique"}>
        <Button className="mt-7">Retour à la boutique</Button>
      </Link>
    </div>
  );
};

export default ConfirmerAchatPage;
